import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Injector,
} from '@angular/core';
import { faCheckDouble } from '@fortawesome/free-solid-svg-icons';
import { every } from '@sama/micro-dash';
import { DirectiveSuperclass } from '@sama/ng-core';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { OutputKeyboardShortcutService } from '../../../../../../../core/outputs/annotation/annotation-shared/utils/output-keyboard-shortcut.service';
import { ShapeSelectionService } from '../../../../../../../core/outputs/annotation/annotation-shared/utils/shape-selection.service';
import { RootKeyboardShortcutService } from '../../../../../../../core/shared/keyboard-shortcuts/root-keyboard-shortcut.service';
import { EventTrackingValueWithSource } from '../../../../../../../cross-team-shared/misc-utils';
import { outputAnnotationInfoStoreToken } from '../../../../annotation-providers';

@Component({
  selector: 'h3-select-all-button',
  templateUrl: './select-all-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SelectAllButtonComponent extends DirectiveSuperclass {
  disabled$ = combineLatest([
    inject(outputAnnotationInfoStoreToken)('shapes').$,
    this.shapeSelectionService.getSelectionForOutput$(),
  ]).pipe(
    // @ts-ignore -- fix me
    map(([shapes, selection]) =>
      // @ts-ignore -- fix me
      every(shapes, (shape) => selection[shape.index]),
    ),
  );
  tooltip: string;
  faCheckDouble = faCheckDouble;

  constructor(
    private shapeSelectionService: ShapeSelectionService,
    injector: Injector,
    outputKeyboardShortcutService: OutputKeyboardShortcutService,
    rootKeyboardShortcutService: RootKeyboardShortcutService,
  ) {
    super(injector);
    this.tooltip =
      'Select All' +
      rootKeyboardShortcutService.tooltipSuffix('selectAllShapes');
    this.subscribeTo(
      outputKeyboardShortcutService.getEvent$('selectAllShapes'),
      ({ keyboardEvent, eventTrackingValue }) => {
        // so ctrl+a does not select the text on the page
        keyboardEvent.preventDefault();
        this.shapeSelectionService.selectAllObjectless(eventTrackingValue);
      },
    );
  }

  selectAll(eventTrackingValue?: EventTrackingValueWithSource) {
    this.shapeSelectionService.selectAllObjectless({
      source: 'select_all_button',
      ...eventTrackingValue,
    });
  }
}
